import { useEffect } from 'react'
import { ISegments, ITrackConversionPair, TSourceChannel } from '../types'
import { useTrackConversionPair } from './useTrackConversionPair'
import { TEmailUtmContent, useTrackConversionParams } from './useTrackConversionParams'

interface ITrackConversionContextState {
  utmSource?: string
  sourceChannel: ITrackConversionPair['sourceChannel']
  sourceSegment: ITrackConversionPair['sourceSegment']
  setTrackConversion: <K extends TSourceChannel>(
    sourceChannel: K,
    sourceSegment: ISegments[K] | undefined
  ) => void
  clearTrackConversionData: () => void
}

export const useTrackConversionContextState = (): ITrackConversionContextState => {
  const { isEmail, params } = useTrackConversionParams()
  const { eventSource, utmContent, utmMedium, utmSource } = params || {}

  const { clearConversion, conversion, setTrackConversion } = useTrackConversionPair()
  const { sourceChannel, sourceSegment } = conversion || {}

  // check if data coming from url is email related - then set track conversion properly
  useEffect(() => {
    const emailUtmContent = utmContent as TEmailUtmContent
    if (isEmail) {
      setTrackConversion('email', `lane_alert_${emailUtmContent}`)
    }
  }, [eventSource, isEmail, setTrackConversion, utmContent, utmMedium, utmSource])

  return {
    utmSource,
    sourceChannel,
    sourceSegment,
    setTrackConversion,
    clearTrackConversionData: clearConversion,
  }
}

export const trackConversionContextInitialState: ITrackConversionContextState = {
  sourceChannel: undefined,
  sourceSegment: undefined,
  setTrackConversion: () => {},
  clearTrackConversionData: () => {},
}
